import { render, staticRenderFns } from "./AnnualPerformanceReport.vue?vue&type=template&id=afc612d2&scoped=true&"
import script from "./AnnualPerformanceReport.vue?vue&type=script&lang=js&"
export * from "./AnnualPerformanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc612d2",
  null
  
)

export default component.exports